import { create } from 'zustand'
import type { DuplicateCheckResult } from '../types/registration'

interface RegistrationState {
  // Image upload state
  profilePhotoPreview: string | null
  paymentScreenshotPreview: string | null
  isUploadingProfilePhoto: boolean
  isUploadingPaymentScreenshot: boolean
  profilePhotoUrl: string | null
  paymentScreenshotUrl: string | null

  // Duplicate check state
  duplicateData: DuplicateCheckResult | null
  showDuplicateDialog: boolean

  // Actions
  setProfilePhotoPreview: (preview: string | null) => void
  setPaymentScreenshotPreview: (preview: string | null) => void
  setUploadingProfilePhoto: (uploading: boolean) => void
  setUploadingPaymentScreenshot: (uploading: boolean) => void
  setProfilePhotoUrl: (url: string | null) => void
  setPaymentScreenshotUrl: (url: string | null) => void
  setDuplicateData: (data: DuplicateCheckResult | null) => void
  setShowDuplicateDialog: (show: boolean) => void
  reset: () => void
}

const initialState = {
  profilePhotoPreview: null,
  paymentScreenshotPreview: null,
  isUploadingProfilePhoto: false,
  isUploadingPaymentScreenshot: false,
  profilePhotoUrl: null,
  paymentScreenshotUrl: null,
  duplicateData: null,
  showDuplicateDialog: false,
}

export const useRegistrationStore = create<RegistrationState>((set) => ({
  ...initialState,

  setProfilePhotoPreview: (preview) => set({ profilePhotoPreview: preview }),
  setPaymentScreenshotPreview: (preview) => set({ paymentScreenshotPreview: preview }),
  setUploadingProfilePhoto: (uploading) => set({ isUploadingProfilePhoto: uploading }),
  setUploadingPaymentScreenshot: (uploading) => set({ isUploadingPaymentScreenshot: uploading }),
  setProfilePhotoUrl: (url) => set({ profilePhotoUrl: url }),
  setPaymentScreenshotUrl: (url) => set({ paymentScreenshotUrl: url }),
  setDuplicateData: (data) => set({ duplicateData: data }),
  setShowDuplicateDialog: (show) => set({ showDuplicateDialog: show }),
  reset: () => set(initialState),
}))
